import { Text } from '@thanx/uikit/text'
import { Toggle } from '@thanx/uikit/toggle'
import { PermissionTooltip } from 'components/Navbar/Bar/PermissionTooltip'
import Section from 'components/Section'
import useCurrentMerchant from 'hooks/useCurrentMerchant'
import { buildTranslate } from 'locales'
import React from 'react'
import CmsPage from 'scenes/Cms/components/CmsPage'
import { useAbility } from 'utilities/ability'
import OrderingNotEnabledPage from '../OrderingNotEnabledPage'
import usePromoCodeVisibility from './hooks/usePromoCodeVisibility'

const t = buildTranslate('cms.settings.promo_code_visibility')

const TOGGLE_LABEL_ID = 'promo-code-visibility-toggle-label'
const TOGGLE_PERMISSION_TOOLTIP_ID = 'promo-code-visibility-toggle-permission'

const PromoCodeVisibility: React.FC<{ showTitle?: boolean }> = ({
  showTitle = true,
}) => {
  const merchant = useCurrentMerchant()
  const ability = useAbility()
  const canEdit = ability.can('manage', 'OrderingManagement')
  const { isHidden, isLoading, isSaving, handleToggle } =
    usePromoCodeVisibility()

  if (!merchant?.ordering_enabled) {
    return <OrderingNotEnabledPage showTitle={showTitle} />
  }

  return (
    <CmsPage
      showTitle={showTitle}
      title={t('title')}
      description={t('description')}
      isLoading={isLoading}
    >
      <Section className="p-m">
        <div className="d-flex align-items-start">
          <PermissionTooltip
            disabled={!canEdit}
            reason={t('disabled_permission_reason')}
            id={TOGGLE_PERMISSION_TOOLTIP_ID}
            inline
            srOnlyReason
          >
            <Toggle
              checked={isHidden}
              onChange={handleToggle}
              disabled={!canEdit || isSaving}
              className="me-3"
              overrides={{
                Input: {
                  props: {
                    role: 'switch',
                    'aria-labelledby': TOGGLE_LABEL_ID,
                  },
                },
              }}
            />
          </PermissionTooltip>
          <div className="d-flex flex-column">
            <Text.BodyText3 bold>
              <span id={TOGGLE_LABEL_ID}>{t('field_label')}</span>
            </Text.BodyText3>
            <Text.BodyText3 color="grey70">
              {t('field_description')}
            </Text.BodyText3>
          </div>
        </div>
      </Section>
    </CmsPage>
  )
}

export default PromoCodeVisibility
